import { useUserEventLogger } from '@repo/tracking-service';
import { TopNavigation } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';

import s from '@/components/my/common/layout.module.scss';

export const MenuLayerTopNavigation = () => {
  const { sendClickEvent } = useUserEventLogger();
  const { back } = useRouter();

  const handleBackClick = () => {
    sendClickEvent('more_topnav_back');

    back();
  };
  return <TopNavigation.Basic leftIcon={'back'} onLeftClick={handleBackClick} className={s.nav_position} />;
};
